module.exports = __webpack_public_path__ + "static/img/1961_01_23_Minneapolis_Review.91b9c32.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cage/archive/1961_01_23_Minneapolis_Review.jpg
// module id = gVuR
// module chunks = 0